import React, { useEffect, useState } from "react";
import { QuestionsInterface } from "../../interfaces/info.interface";
import { get, put, remove } from "../../redux/ApiHelper";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { successToast } from "../../utils/toast.util";

const VideoVerificationQuestions = () => {
  const { info } = useSelector((state: RootState) => state.info);
  const [questions, setQuestions] = useState<QuestionsInterface[]>([]);
  const [newQuestion, setNewQuestion] = useState("");
  const [timeInMins, setTimeInMins] = useState("");
  const [error, setError] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdate = async (ques) => {
    setIsUpdating(true);
    const res = await put("/admin/teacher-video-question/create-update", {
      questions: ques,
    });
    successToast(res.message);
    setIsUpdating(false);
  };

  const handleDeleteRequest = async (index) => {
    setIsUpdating(true);
    const res = await remove(`/admin/teacher-video-question/delete/${index}`);
    successToast(res.message);
    setIsUpdating(false);
  };

  const handleAddQuestion = () => {
    if (!newQuestion.trim()) {
      setError("Question is required.");
      return;
    }
    if (!timeInMins.trim()) {
      setError("Time in minutes is required.");
      return;
    }
    if (parseInt(timeInMins, 10) <= 0) {
      setError("Time must be greater than 0.");
      return;
    }

    const updated = [...questions, { question: newQuestion, timeInMins }];
    handleUpdate(updated);

    setQuestions(updated);

    // reset
    setNewQuestion("");
    setTimeInMins("");
    setError("");
  };

  const handleDelete = (index: number) => {
    const updated = questions.filter((_, i) => i !== index);
    handleDeleteRequest(index);
    setQuestions(updated);
  };
  const getQuestions = async () => {
    const res = await get("/admin/teacher-video-question/questions");
    setQuestions(res.questions);
  };
  useEffect(() => {
    getQuestions();
  }, [isUpdating]);

  return (
    <div className="w-full max-w-3xl mx-auto space-y-4 mt-5">
      {/* Add Question Form */}
      <div className="flex flex-col gap-2 p-4 border border-gray-300 rounded-md bg-white shadow-sm">
        <textarea
          placeholder="Enter question *"
          value={newQuestion}
          onChange={(e) => setNewQuestion(e.target.value)}
          className="border border-gray-300 rounded-md p-2 text-sm"
        />
        <input
          type="number"
          placeholder="Time in minutes *"
          value={timeInMins}
          onChange={(e) => setTimeInMins(e.target.value)}
          className="border border-gray-300 rounded-md p-2 text-sm"
        />
        {error && <div className="text-red-500 text-xs">{error}</div>}
        <button
          onClick={handleAddQuestion}
          className="px-4 py-2 text-sm rounded-md bg-gray-600 text-white hover:bg-gray-500"
        >
          Add Question
        </button>
      </div>

      {/* Questions List */}
      <div className="p-4 border border-gray-300 rounded-md bg-white shadow-sm space-y-2">
        {questions.length === 0 ? (
          <div className="text-gray-500 text-sm">No questions added yet.</div>
        ) : (
          questions.map((q, index) => (
            <div
              key={index}
              className="flex justify-between items-center border-b last:border-none pb-2"
            >
              <div>
                <div className="font-medium text-sm break-text text-left">
                  {q.question}
                </div>
                <div className="text-xs text-gray-500">
                  Time: {q.timeInMins} min(s)
                </div>
              </div>
              <button
                onClick={() => handleDelete(index)}
                className="text-white text-xs hover:underline bg-red-500"
              >
                Delete
              </button>
            </div>
          ))
        )}
      </div>

      {/* Total Questions */}
      <div className="text-sm text-gray-600">
        Total Questions: {questions.length}
      </div>
    </div>
  );
};

export default VideoVerificationQuestions;
